export const partnerGeneralInfoPanelTranslation = {
  labels: {
    partnerId: 'cng-partner_general_info_panel-labels-partner_id',
    locationId: 'cng-partner_general_info_panel-labels-location_id',
    communicationName: 'cng-partner_general_info_panel-labels-communication_name',
    hierarchyType: 'cng-partner_general_info_panel-labels-hierarchy_type',
    onboardingRequestId: 'cng-partner_general_info_panel-labels-onboarding_request_id',
  },
  default: {
    partnerId: 'cng-partner_general_info_panel-default-partner_id',
  },
}
